import buildPath from '@tsClient/utilities/buildPath';
import noodleApiClient, { ApiDefinition } from '@noodleApi';

const PATH_TEMPLATE = '/creators/{creatorId}/user-workflows';
type THIS_API = ApiDefinition['/creators/{creatorId}/user-workflows']['PUT'];
type Input = THIS_API['params'] & THIS_API['query'] & THIS_API['body'];
type Output = THIS_API['response'];

const getUserWorkflows = async ({
  initiateMemberIds,
  assignedTeamMemberIds,
  clientTaskFilters,
  endDate,
  personId,
  companyId,
  creatorId,
  initiatedByPersonId,
  unassigned,
  page,
  perPage,
  search,
  status,
  statusNot,
  startDate,
  sortDirection,
  sortField,
}: Input): Promise<Output> => {
  const body = {
    assignedTeamMemberIds,
    clientTaskFilters,
    companyId,
    endDate,
    initiateMemberIds,
    initiatedByPersonId,
    personId,
    search,
    sortDirection,
    sortField,
    startDate,
    status,
    statusNot,
    unassigned,
  };
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { creatorId });
  const data = await noodleApiClient.put(path,
    body,
    {
      params: {
        page,
        perPage,
      },
    },
  );
  return data.data;
};

export default getUserWorkflows;
